import { useQuery } from "@tanstack/react-query";
import { api, unwrap } from "./client";

/** Query key of `useMe`, for invalidation after profile or workspace changes. */
export const ME_KEY = ["me"] as const;

/** The signed-in user and their workspace. */
export function useMe() {
  return useQuery({
    queryKey: ME_KEY,
    queryFn: async () => unwrap(await api.GET("/v1/auth/me")),
    staleTime: 60_000,
  });
}

type Me = NonNullable<ReturnType<typeof useMe>["data"]>;

/** The signed-in user, or null for API-key principals and while loading. */
export function meUser(me: Me | undefined) {
  return me && "user" in me ? me.user : null;
}
